import { CUSTOM_CHANNEL } from '@disco/constants/GroupTypes'
import type { GROUP_TYPE } from '@disco/constants/GroupTypes'
import type { SORT, SORT_DIRECTION } from '@disco/constants/SortTypes'
import {
  PLAYLIST_DATE_SORT,
  SORT_DIRECTION_ASC,
  TRACK_DATE_SORT,
} from '@disco/constants/SortTypes'
export function getSortParam(
  groupType: GROUP_TYPE | null | undefined,
  sortParam: SORT,
  sortDirection: SORT_DIRECTION | null | undefined,
): string {
  if (groupType !== CUSTOM_CHANNEL) {
    return sortDirection === SORT_DIRECTION_ASC
      ? `["${sortParam}"]`
      : `["-${sortParam}"]`
  }

  const sortParams = [sortParam]
  // backend use different params for playlist and track date sort, add each
  // to channel sort settings if sort by date is chosen
  if (sortParams[0] === PLAYLIST_DATE_SORT) sortParams.push(TRACK_DATE_SORT)
  const preparedSortParams = sortParams
    .map(param => {
      return sortDirection === SORT_DIRECTION_ASC ? `"${param}"` : `"-${param}"`
    })
    .join(',')
  return `["-is_playlist",${preparedSortParams}]`
}
